var initFBLogin = function () {
    if (typeof sFbAppId !== "undefined" && sFbAppId !== "") {
        $.ajaxSetup({ cache: true });
        $.getScript('https://connect.facebook.net/' + sLocale + '/sdk.js', function () {
            FB.init({
                appId: sFbAppId,
                version: 'v2.7'
            });
            initFBLoginButton();
        });
    }
}
var initFBLoginButton = function () {
    $("body #btnFLogin").prop('disabled',false);
    $("body #btnFLogin").on("click", function (event) {
        event.preventDefault();
        FB.login(function (response) {
            checkFacebookData(response);
        }, { scope: 'email,user_birthday', return_scopes: true });
        return false;
    });
}

var checkFacebookData = function (fbResponse) {
    if (fbResponse.status === 'connected') {
        // User logged in, log in or register
        FB.api('/me', { fields: 'name, email, birthday, first_name, last_name' }, function (response) {
            doFacebookLogin(response);
        });
    } else {
        initFBLoginButton();
    }
}

var doFacebookLogin = function (fbResponse) {
    $("body #btnFLogin").prop('disabled', true).addClass("loading");
    var sParams = '&email=' + fbResponse.email + "&id=" + fbResponse.id + "&type=facebook&birthday=" + fbResponse.birthday + "&firstname=" + encodeURIComponent(fbResponse.first_name) + "&lastname=" + encodeURIComponent(fbResponse.last_name) + "&name=" + encodeURIComponent(fbResponse.name);
    uAjax = "/index.cfm/customer/ajax/social";
    var oCall = callAjax("social", sParams, "post");

    // process result
    oCall.success(function (oData) {
        if (oData.errorType == '') {
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
                'event': 'login',
                'method': 'Facebook'
            });

            var urlParams = new URLSearchParams(window.location.search);
            var returnUrl = urlParams.get('returnUrl');

            if (returnUrl) {
                window.location = returnUrl;
            }
            else if (typeof sRedirect !== 'undefined' && sRedirect !== '')
            {
                if (sRedirect.indexOf("/quickcheckout") >= 0)
                {
                    sRedirect += '/true/true/' + fbResponse.email;
                }
                window.location = sRedirect;
            }
            else {
                window.location = '/' + sCurrentLanguageCode + '/transaction';
            }
        }
        else {
            $("body #btnFLogin").prop('disabled', false).removeClass("loading");
            inlineAlert('error', oData.errorMessage, oData.errorUnhandled, $(el('btnFLogin')));
        }
    });
}